import OutlookFolders from "./OutlookFolders";
import { setCurrentMail } from "../../../Slices/notification";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import OutlookLoginPage from "./OutlookLoginPage";
import { useEffect, useState } from "react";

export const PersonalMailTab = () => {
  const dispatch = useDispatch();
  const userEmail = useSelector((state) => state?.loginUserInfo?.loginUserDetails?.email);
  const [isOutlookLoggedIn, setIsOutlookLoggedIn] = useState(false);
  const [checkingLogin, setCheckingLogin] = useState(true);

  useEffect(() => {
    const outlookToken = localStorage.getItem("outlookToken");
    if (outlookToken && userEmail) {
      setIsOutlookLoggedIn(true);
      dispatch(setCurrentMail(userEmail));
    }
    setCheckingLogin(false);
  }, [userEmail, dispatch]);

  if (checkingLogin) {
    // 👇 render nothing while checking
    return null;
  }

  return !isOutlookLoggedIn ? (
    <OutlookLoginPage onLoginSuccess={() => setIsOutlookLoggedIn(true)} />
  ) : (
    <OutlookFolders EmailsList={[userEmail]} mode={false} />
  );
};